module.exports = __webpack_public_path__ + "img/muna-full-sm.557e9879.jpg";